<h2 mat-dialog-title class="dialog-header">{{'finance.payment.generateInvoice.title'|traduccion}}
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content class="dialog-content">
  <div appGridColumns [colsLg]="1" [colsMd]="1" [colsSm]="1">
    <mat-card class="assign-card">
      <mat-card-content>
        <h6>{{'finance.payment.generateInvoice.table.title'|traduccion}}</h6>
        <app-data-table
          preset="modal"
          shellClass="table-card mat-elevation-z1"
          [dataSource]="dataSource"
          [displayedColumns]="displayedColumns"
          [emptyMessage]="'No hay pagos seleccionados.'"
          [showPaginator]="true"
          [clientPagination]="true"
          [pageSize]="10"
          [pageSizeOptions]="[10, 25, 50]"
          [showFirstLastButtons]="true"
          [stickyHeader]="true">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.generateInvoice.table.header.uuid'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">{{ r.uuid }}</td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.generateInvoice.table.header.createdAt'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">{{ r.createdAt | date:'dd-MM-yyyy HH:mm' }}</td>
          </ng-container>

          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.generateInvoice.table.header.totalPrice'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">{{ r.totalPrice|currency }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.generateInvoice.table.header.status'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">
              <app-data-table-badge
                [label]="r.status"
                [tone]="r.status === 'KO' ? 'danger' : (r.status === 'PENDING' ? 'warning' : 'success')">
              </app-data-table-badge>
            </td>
          </ng-container>

          <ng-container matColumnDef="invoiceToGenerate">
            <th mat-header-cell *matHeaderCellDef>{{'finance.payment.generateInvoice.table.header.invoiceToGenerate'|traduccion}}</th>
            <td mat-cell *matCellDef="let r">
              <app-data-table-badge
                [label]="r.customer ? 'COMPLETA' : 'SIMPLIFICADA'"
                [tone]="r.customer ? 'success' : 'warning'">
              </app-data-table-badge>
            </td>
          </ng-container>
        </app-data-table>
      </mat-card-content>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button mat-raised-button color="primary" [disabled]="!selectedRows" (click)="generateInvoiceMassive()">
    <mat-icon>link</mat-icon>
    {{'finance.payment.generateInvoice.action'|traduccion}}
  </button>
</mat-dialog-actions>
